import { Injectable } from '@angular/core';
import { Video } from '../components/video-player/video.model';
import { UpaService, UpaTarget } from './upa.service';

export interface VideoTrackingData {
    moduleId: string;
    uniqueId?: string;
    moduleIndex: number;
    positionIndex?: number;
}

export interface VideoData {
    showVideoPlayer: boolean;
    playing: boolean;
    video?: Video;
    trackingData?: VideoTrackingData;
}

@Injectable({providedIn: 'root'})
export class VideoPlayerService {
    public videoData: VideoData = {
        showVideoPlayer: false,
        playing: true,
        video: undefined,
        trackingData: undefined
    };

    constructor(private upaService: UpaService) { }

    show(trackingData: VideoTrackingData, video: Video): void {
        this.upaService.trackClickTopic({
            label: 'openVideo',
            moduleId: trackingData.moduleId,
            moduleIndex: trackingData.moduleIndex,
            positionIndex: trackingData.positionIndex,
            uniqueId: trackingData.uniqueId,
            target: UpaTarget.IMAGE
        });

        document.body.style.overflow = 'hidden';

        this.videoData.showVideoPlayer = true;
        this.videoData.playing = true;
        this.videoData.video = video;
        this.videoData.trackingData = trackingData;
    }

    close(trackingData: VideoTrackingData) {
        this.upaService.trackClickTopic({
            label: 'closeVideo',
            moduleId: trackingData.moduleId,
            moduleIndex: trackingData.moduleIndex,
            positionIndex: trackingData.positionIndex,
            uniqueId: trackingData.uniqueId,
            target: UpaTarget.IMAGE,
        });

        document.body.style.overflow = '';

        this.videoData.showVideoPlayer = false;
        this.videoData.video = undefined;
    }

}
